import PropTypes from "prop-types";
import React from "react";
import Swiper from "react-id-swiper";
import SectionTitle from "../../components/section-title/SectionTitle";
import ProductGrid from "./ProductGrid";

const RelatedProductSlider = ({
  spaceBottomClass,
  category,
  thisProduct,
  template,
}) => {
  const settings = {
    slidesPerView: 4,
    grabCursor: true,
    spaceBetween: 30,
  };

  return (
    <div
      className={`related-product-area ${
        spaceBottomClass ? spaceBottomClass : ""
      }`}
    >
      <div className="container">
        <SectionTitle
          titleText="Prodotti Correlati"
          positionClass="text-center"
          spaceClass="mb-20"
        />
        <div className="row">
          <Swiper {...settings}>
            <ProductGrid
              thisProduct={thisProduct}
              category={category}
              template={template}
              limit={1000}
              sliderClassName="swiper-slide"
              spaceBottomClass={spaceBottomClass}
            />
          </Swiper>
        </div>
      </div>
    </div>
  );
};

RelatedProductSlider.propTypes = {
  category: PropTypes.string,
  spaceBottomClass: PropTypes.string,
};

export default RelatedProductSlider;
